import { request } from '@/api/client';
import type {
  DeveloperApiKey,
  DeveloperApiKeyCreateResponse,
  DeveloperApiKeyListResponse,
  DeveloperUsageSummary,
} from '@/types';

export const developerService = {
  listKeys: (): Promise<DeveloperApiKeyListResponse> =>
    request<DeveloperApiKeyListResponse>('/developer/api-keys', {
      method: 'GET',
      auth: true,
    }),

  createKey: (name: string): Promise<DeveloperApiKeyCreateResponse> =>
    request<DeveloperApiKeyCreateResponse>('/developer/api-keys', {
      method: 'POST',
      auth: true,
      body: JSON.stringify({ name }),
    }),

  revokeKey: (keyId: string): Promise<DeveloperApiKey> =>
    request<DeveloperApiKey>(`/developer/api-keys/${encodeURIComponent(keyId)}`, {
      method: 'DELETE',
      auth: true,
    }),

  rotateKey: (keyId: string): Promise<DeveloperApiKeyCreateResponse> =>
    request<DeveloperApiKeyCreateResponse>(
      `/developer/api-keys/${encodeURIComponent(keyId)}/rotate`,
      {
        method: 'POST',
        auth: true,
      }
    ),

  getUsage: (days = 30): Promise<DeveloperUsageSummary> =>
    request<DeveloperUsageSummary>(`/developer/usage?days=${encodeURIComponent(days)}`, {
      method: 'GET',
      auth: true,
    }),
};
